import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FilesDroppedOnStructureEvent } from '../../../views/site/structure/structure.file-drop.event';
import { AsyncJob } from '../../models/async-job.model';
import { Form } from '../../models/form-builder/form.model';
import { AsyncJobService } from '../../services/async-job.service';
import { ImportDataService } from '../../services/import-data.service';
import { CurrentSiteService } from '../../services/current-site.service';
import { ImportAsyncJobDialogBase } from '../async-job-base/import-async-job-base.dialog';
import { ImportFormInstancesMetrics } from '../../models/export-import/import-form-instances-metrics.model';
import { DragDropEnum } from '../../enums/drag-drop.enum';
import { XmlFileFormatEnum } from '../../enums/xml-file-format.enum';
import { ImportMetadataService } from '../../services/import-metadata.service';

@Component({
    selector: 'app-import-drag-drop',
    templateUrl: './import-drag-drop.component.html',
    styleUrls: ['./import-drag-drop.component.scss'],
    standalone: false
})
export class ImportDragDropComponent extends ImportAsyncJobDialogBase implements OnInit {
    // Properties.
    private targetFolderId: number = -1;

    private isUploading: boolean = false;
    private hasError: boolean = false;


    // File-related properties.
    @ViewChild('file') file;
    private desc: string = '';
    private selectedFileName: string = null;

    private arrFiles: File[];

    // 10-28-2021 note:  added the following property to keep track of incremental progress.
    private importFormInstancesMetrics: ImportFormInstancesMetrics = null;

    // Constructor.
    public constructor(public dialogRef: MatDialogRef<ImportDragDropComponent>,
        @Inject(MAT_DIALOG_DATA) public targetObject: FilesDroppedOnStructureEvent,
        public dialog: MatDialog,
        private importDataService: ImportDataService,
        private importMetadataService: ImportMetadataService,
        private injectedAsyncJobService: AsyncJobService,
        private currentSiteService: CurrentSiteService) {
        super(injectedAsyncJobService);

        dialogRef.disableClose = true; // Disable closing the dialogue when the user clicks on the page.

        return;
    }

    // Implement a base class's abstract method.
    public get ComponentClassName(): string {
        return 'ImportDragDropComponent';
    }

    ngOnInit(): void {

        this.isUploading = false;
        this.hasError = false;

        this.createFileSet(this.targetObject.getFiles());
        this.targetFolderId = this.targetObject.getToDropFolderId();

        let folderName = this.targetObject.getFolderName();

        if (folderName && folderName != "")
            folderName = ' "' + folderName + '"?';
        else
            folderName = '?';

        this.desc = `Are you sure you want to import the ${this.targetObject.getObjectType()}`;

        if (this.arrFiles.length > 1) {
            this.desc += 's:\n\n';
        }
        else {
            this.desc += ':\n\n';
        }

        this.arrFiles.forEach(x => {
            this.desc += x.name + '\n';
        });
        this.desc += '\n';

        this.desc += `into ${this.targetObject.getSiteOrFolder()}${folderName}`;

        return;
    }

    public get Description(): string {
        return this.desc;
    }

    public get IsUploading(): boolean {
        return this.isUploading;
    }

    public get HasError(): boolean {
        return this.hasError;
    }

    public get ExecutionSummaryText(): string {
        let summaryText: string = super.deriveExecutionSummaryText(this.importFormInstancesMetrics);

        return (summaryText);
    }

    // Handle control events.
    public startStructureImport(): void {
        // Initiate the import.

        let objectType = this.targetObject.getObjectType();

        if (this.arrFiles.length > 0) {
            if (objectType == DragDropEnum.FORM) {

                this.importDataService.importFormInstanceFiles(this.arrFiles, this.targetFolderId).then(asyncJob => {
                    this.isUploading = true;
                    this.startMonitoringJob(asyncJob, this.jobCompletedArrowFunction, this.jobCompletedArrowFunction);
                });
            }

            if (objectType == DragDropEnum.FORM_TEMPLATE) {

                this.importMetadataService.importFormDefinitions(this.arrFiles, this.currentSiteService.Site.id, XmlFileFormatEnum.VERBOSE_FORMAT).then(asyncJob => {
                    this.isUploading = true;
                    this.startMonitoringJob(asyncJob, this.jobCompletedArrowFunction, this.jobCompletedArrowFunction);
                });
            }
        }
    }



    

    public okClicked(): void {
        this.dialogRef.close(null);
    }

    public cancelClicked(): void {
        this.dialogRef.close(null);
    }

    // Private methods.
    private jobCompletedArrowFunction = (asyncJob: AsyncJob): void => {
        // 10-28-2021:  added the if-else logic.
        if (this.jobCompleted) {
            if (asyncJob.stdError) {
                this.isUploading = false;
                this.hasError = true;

                this.desc = "There was an error with the upload, the message returned was:\n\n" + asyncJob.stdError;
            }

            if (!this.hasError)
                this.dialogRef.close(null);
        } else if ((asyncJob.stdOut != null) && (asyncJob.stdOut.trim() != '')) {
            this.importFormInstancesMetrics = ImportAsyncJobDialogBase.parseImportFormInstancesMetrics(asyncJob.stdOut);
        }
    }


    public createFileSet(passedFiles: any) {
        this.arrFiles = [];

        // Save the selected file.
        const files: { [key: string]: File } = passedFiles;

        for (let key in files) {
            if (!isNaN(parseInt(key))) {
                let selectedFile: File = files[key];

                this.arrFiles.push(selectedFile);

                this.selectedFileName = selectedFile.name;
            }
        }

        return;
    }



}
